module.exports = __webpack_public_path__ + "pc/img/ico-anniv-hover.742b47d2.svg";